/*eslint no-unreachable: "off"*/
/*eslint no-useless-concat: "off"*/
/*eslint no-array-constructor: "off"*/
/*eslint no-unused-vars: "off"*/
// 전파자원이용자지수
//////////////////////////////////
// 공통 변수
//////////////////////////////////


import React from "react";

let sidoGbFirst = "";//처음화면 열었을때 전국과 시군을 비교할수있도록 처라를 위한 변수
let sidoGbNm = "";
let gugunCd = "";
let gugunNm = "";
let chartBaseData = {};

export function layoutForChart1() {
  let layoutStr =
    '<rMateChart backgroundColor="#FFFFFF"  borderStyle="none">'
    + '<Options>'
    + '<Caption fontSize="15" text="전파·도시화 지수" />'
    + '<Legend useVisibleCheck="true" defaultMouseOverAction="true" fontFamily="맑은 고딕" fontSize="15" position="bottom" direction="horizontal" horizontalGap="10"/>'
    + '</Options>'
    + '<RadarChart isSeriesOnAxis="false" type="polygon" paddingTop="0" paddingBottom="0" paddingLeft="80" paddingRight="80" showDataTips="true" mouseSensitivity="4">'
    /*
       Radar 차트 생성시에 필요한 RadarChart 정의합니다
    showDataTips : 데이터에 마우스를 가져갔을 때 나오는 Tip을 보이기/안보이기 속성입니다.
       isSeriesOnAxis : 차트 시리즈가 radialAxis위에 표현될지 여부를 나타냅니다
       type - circle, polygon : Rader차트의 타입(원형, 다각형)입니다
      이 예제에서는 polygon입니다
     */
    + '<radialAxis>'
    + '<LinearAxis id="rAxis" maximum="10" interval="1"/>'
    + '</radialAxis>'
    + '<angularAxis>'
    + '<CategoryAxis id="aAxis" categoryField="GUBUN_NM" displayName="구분"/>'
    + '</angularAxis>'
    + '<radialAxisRenderers>'
    /* radialAxis렌더러 정의 */
    /* 가로, 세로축 모두 표시 */
    + '<Axis2DRenderer axis="{rAxis}" horizontal="true" visible="true" tickPlacement="outside"/>'
    + '<Axis2DRenderer axis="{rAxis}" horizontal="false" visible="true" tickPlacement="outside"/>'
    + '</radialAxisRenderers>'
    + '<angularAxisRenderers>'
    + '<AngularAxisRenderer axis="{aAxis}"/>'
    + '</angularAxisRenderers>'
    + '<series>'
    + '<RadarSeries radius="4" id="avg" field="AVG_GRAD" displayName="전국 시도 평균">'
    + '<lineStroke>'
    + '<Stroke color="#41b2e6" weight="2"/>'
    + '</lineStroke>'
    + '<fill>'
    + '<SolidColor color="#41b2e6"/>'
    + '</fill>'
    /* RadarChart 정의 후 RadarSeries 정의합니다 */
    + '<showDataEffect>'
    /*  차트 생성시에 Effect를 주고 싶을 때 shoDataEffect정의합니다 */
    + '<SeriesInterpolate/>'
    /*
     SeriesInterpolate는 시리즈 데이터가 새로운 시리즈 데이터로 표시될 때 이동하는 효과를 적용합니다
   - 공통속성 -
     elementOffset : effect를 지연시키는 시간을 지정합니다 default:20
   minimumElementDuration : 각 엘리먼트의 최소 지속 시간을 설정합니다 default:0
                이 값보다 짧은 시간에 effect가 실행되지 않습니다
  offset : effect개시의 지연시간을 설정합니다 default:0
     perElementOffset : 각 엘리먼트의 개시 지연시간을 설정합니다
    */
    + '</showDataEffect>'
    + '</RadarSeries>';

  if(sidoGbFirst !==""){
    layoutStr+='<RadarSeries radius="4" id="area" field="GRAD" displayName="' + sidoGbNm + '">'
        +'<lineStroke>'
        +'<Stroke color="red" weight="2"/>'
        +'</lineStroke>'
        +'<fill>'
        +'<SolidColor color="red"/>'
        +'</fill>'
        /* RadarChart 정의 후 RadarSeries 정의합니다 */
        +'<showDataEffect>'
        /*  차트 생성시에 Effect를 주고 싶을 때 shoDataEffect정의합니다 */
        +'<SeriesInterpolate/>'
        /*
         SeriesInterpolate는 시리즈 데이터가 새로운 시리즈 데이터로 표시될 때 이동하는 효과를 적용합니다
       - 공통속성 -
         elementOffset : effect를 지연시키는 시간을 지정합니다 default:20
       minimumElementDuration : 각 엘리먼트의 최소 지속 시간을 설정합니다 default:0
                    이 값보다 짧은 시간에 effect가 실행되지 않습니다
      offset : effect개시의 지연시간을 설정합니다 default:0
         perElementOffset : 각 엘리먼트의 개시 지연시간을 설정합니다
        */
        +'</showDataEffect>'
        +'</RadarSeries>';
  }

  if(gugunNm !== "") {
    layoutStr+='<RadarSeries radius="4" id="area" field="DTL_GRAD" displayName="' + gugunNm + '">'
        +'<lineStroke>'
        +'<Stroke color="green" weight="2"/>'
        +'</lineStroke>'
        +'<fill>'
        +'<SolidColor color="green"/>'
        +'</fill>'
        /* RadarChart 정의 후 RadarSeries 정의합니다 */
        +'<showDataEffect>'
        /*  차트 생성시에 Effect를 주고 싶을 때 shoDataEffect정의합니다 */
        +'<SeriesInterpolate/>'
        /*
         SeriesInterpolate는 시리즈 데이터가 새로운 시리즈 데이터로 표시될 때 이동하는 효과를 적용합니다
       - 공통속성 -
         elementOffset : effect를 지연시키는 시간을 지정합니다 default:20
       minimumElementDuration : 각 엘리먼트의 최소 지속 시간을 설정합니다 default:0
                    이 값보다 짧은 시간에 effect가 실행되지 않습니다
      offset : effect개시의 지연시간을 설정합니다 default:0
         perElementOffset : 각 엘리먼트의 개시 지연시간을 설정합니다
        */
        +'</showDataEffect>'
        +'</RadarSeries>';
  }

  layoutStr += '</series>'
    + '</RadarChart>'
    + '</rMateChart>';

  // chartBaseData["chart1"].layOut = layoutStr;
  return layoutStr;
}


export function layoutForChart2({ DataSub1, DataSub2 }) {
  let layoutStr =
    '<rMateChart backgroundColor="#FFFFFF"  borderStyle="none">'
    + '<Options>'
    + '<Caption fontSize="15" text="인구 밀도 / 정보통신 자격현황" />'
    + '<Legend defaultMouseOverAction="false" useVisibleCheck="true" fontSize="15" />'
    + '</Options>'
    + '<NumberFormatter id="numfmt" precision="2" useThousandsSeparator="true" rounding="none" />'
    + '<Combination2DChart showDataTips="true" dataTipMode="single">'
    + '<horizontalAxis>'
    + '<CategoryAxis id="hAxis" categoryField="GUBUN_NM" padding="1"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis2DRenderer axis="{hAxis}" axisTitleStyleName="title" labelRotation="45" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">'
    + '</Axis2DRenderer>'
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    + '<LinearAxis id="vAxis1" title="인구 밀도" formatter="{numfmt}" labelJsFunction="labelFuncNum"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis2DRenderer axis="{vAxis1}" showLine="false" verticalAxisTitleAlignment="flippedVertical" />'
    + '</verticalAxisRenderers>'
    + '<series>'
    + '<Column2DSeries id="DataSub1" yField="DATA_1_RT" displayName="인구 밀도" showValueLabels="[]">'
    + '<fills>';

  for (let i = 0; i < DataSub1.length; i++) {
    if(chartBaseData["chart2"].DataSub1[i].GUBUN_CD===gugunCd){
      layoutStr +='<SolidColor color="red"/>';
    } else {
      layoutStr += '<SolidColor color="#41b2e6"/>';
    }
  }

  layoutStr += '</fills>'
    + '<showDataEffect>'
    + '<SeriesInterpolate/>'
    + '</showDataEffect>'
    + '</Column2DSeries>'
    + '<Line2DSeries radius="6" id="DataSub2" yField="DATA_2_RT" displayName="정보통신 자격현황" itemRenderer="CircleItemRenderer">'
    + '<verticalAxis>'
    + '<LinearAxis id="vAxis2" title="정보통신 자격현황" formatter="{numfmt}"  labelJsFunction="labelFuncNum"/>'
    + '</verticalAxis>'
    + '<showDataEffect>'
    + '<SeriesInterpolate/>'
    + '</showDataEffect>'
    + '<lineStroke>'
    + '<Stroke color="#f9bd03" weight="4"/>'
    + '</lineStroke>'
    + '<stroke>'
    + '<Stroke color="#f9bd03" weight="3"/>'
    + '</stroke>'
    + '<fills>';

  for (let i = 0; i < DataSub2.length; i++) {
    if(chartBaseData["chart2"].DataSub2[i].GUBUN_CD===gugunCd){
      layoutStr +='<SolidColor color="red"/>';
    } else {
      layoutStr += '<SolidColor color="#f9bd03"/>';
    }
  }

  layoutStr += '</fills>'
    + '</Line2DSeries>'
    + '</series>'
    + '<verticalAxisRenderers>'
    + '<Axis2DRenderer axis="{vAxis1}" showLine="false"/>'
    + '<Axis2DRenderer axis="{vAxis2}" showLine="false"/>'
    + '</verticalAxisRenderers>'
    + '<annotationElements>'
    + '<CrossRangeZoomer zoomType="horizontal"  enableZooming="true" enableCrossHair="false">'
    + '</CrossRangeZoomer>'
    /* CrossRangeZoomer 속성 설명
* zoomType : 줌 실행 기준을 정합니다. 유효값 : horizontal, vertical, both
* horizontalLabelFormatter : 십자가의 수평 라인에 붙는 라벨 formatter 입니다.
* verticalLabelFormatter : 십자가의 수직 라인에 붙는 라벨 formatter 입니다.
* enableZooming : zoom 기능 사용 여부를 나타냅니다.
* enableCrossHair : 십자가 표시 여부를 나타냅니다.
* useDualCrossXLabel : 십자가의 수평 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
* useDualCrossYLabel : 십자가의 수직 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
* verticalLabelPlacement : 수직 라인의 라벨 위치를 지정합니다.(유효값: top, bottom)
* horizontalLabelPlacement : 수평 라인의 라벨 위치를 지정합니다.(유효값 : left, right)
*/
    + '</annotationElements>'
    + '</Combination2DChart>'
    + '<Style>'
    + '.seriesLabel{fontSize:11;color:#ffffff;fontWeight:bold;}'
    + '.title{color : 0x4691E1;fontSize : 15;fontWeight : bold;}'
    + '</Style>'
    + '</rMateChart>';

  return layoutStr;
}


export function layoutForChart3({ DataSub1, DataSub2 }) {
  let layoutStr =
    '<rMateChart backgroundColor="#FFFFFF"  borderStyle="none">'
    + '<Options>'
    + '<Caption fontSize="15" text="시가화 지수 / 무선국 밀도"/>'
    + '<Legend defaultMouseOverAction="false" useVisibleCheck="true" fontSize="15" />'
    + '</Options>'
    + '<NumberFormatter id="numfmt" useThousandsSeparator="true"/>'
    + '<Combination2DChart showDataTips="true">'
    + '<horizontalAxis>'
    + '<CategoryAxis id="hAxis" categoryField="GUBUN_NM" padding="1"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis2DRenderer axis="{hAxis}" axisTitleStyleName="title" labelRotation="45" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">'
    + '</Axis2DRenderer>'
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    + '<LinearAxis id="vAxis1" formatter="{numfmt}" title="시가화 지수" labelJsFunction="labelFuncNum"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis2DRenderer axis="{vAxis1}" showLine="false" verticalAxisTitleAlignment="vertical" />'
    + '</verticalAxisRenderers>'
    + '<series>'
    + '<Column2DSeries id="DataSub1" labelPosition="outside" yField="DATA_1_RT" displayName="시가화 지수" showValueLabels="[]" columnWidthRatio="0.54">'
    + '<fills>';

  for (let i = 0; i < DataSub1.length; i++) {
    if(DataSub1[i].GUBUN_CD===gugunCd){
      layoutStr +='<SolidColor color="red"/>';
    } else {
      layoutStr += '<SolidColor color="#41b2e6"/>';
    }
  }

  layoutStr += '</fills>'
    + '<showDataEffect>'
    + '<SeriesInterpolate/>'
    + '</showDataEffect>'
    + '</Column2DSeries>'
    + '<Line2DSeries radius="6" id="DataSub2" yField="DATA_2_RT" displayName="무선국 밀도" itemRenderer="CircleItemRenderer">'
    + '<verticalAxis>'
    + '<LinearAxis id="vAxis2" title="무선국 밀도" formatter="{numfmt}" labelJsFunction="labelFuncNum"/>'
    + '</verticalAxis>'
    + '<showDataEffect>'
    + '<SeriesInterpolate/>'
    + '</showDataEffect>'
    + '<lineStroke>'
    + '<Stroke color="#f9bd03" weight="4"/>'
    + '</lineStroke>'
    + '<stroke>'
    + '<Stroke color="#f9bd03" weight="3"/>'
    + '</stroke>'
    + '<fills>';

  for (let i = 0; i < DataSub2.length; i++) {
    if(DataSub2[i].GUBUN_CD===gugunCd){
      layoutStr +='<SolidColor color="red"/>';
    } else {
      layoutStr += '<SolidColor color="#f9bd03"/>';
    }
  }

  layoutStr += '</fills>'
    + '</Line2DSeries>'
    + '</series>'
    + '<verticalAxisRenderers>'
    + '<Axis2DRenderer axis="{vAxis1}" showLine="false"/>'
    + '<Axis2DRenderer axis="{vAxis2}" showLine="false"/>'
    + '</verticalAxisRenderers>'
    + '<annotationElements>'
    + '<CrossRangeZoomer zoomType="horizontal"  enableZooming="true" enableCrossHair="false">'
    + '</CrossRangeZoomer>'
    + '</annotationElements>'
    + '</Combination2DChart>'
    + '<Style>'
    + '.seriesLabel{fontSize:11;color:#ffffff;fontWeight:bold;}'
    + '.title{color : 0x4691E1;fontSize : 15;fontWeight : bold;}'
    + '</Style>'
    + '</rMateChart>';

  return layoutStr;
}


export function layoutForChart4({ DataSub1, DataSub2 }) {
  let layoutStr =
    '<rMateChart backgroundColor="#FFFFFF"  borderStyle="none">'
    + '<Options>'
    + '<Caption fontSize="15" text="전파Tech지수 / 재정자주도"/>'
    + '<Legend defaultMouseOverAction="false" useVisibleCheck="true" fontSize="15" />'
    + '</Options>'
    + '<NumberFormatter id="numfmt" useThousandsSeparator="true"/>'
    + '<Combination2DChart showDataTips="true" dataTipMode="single">'
    + '<horizontalAxis>'
    + '<CategoryAxis id="hAxis" categoryField="GUBUN_NM" padding="1"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis2DRenderer axis="{hAxis}" axisTitleStyleName="title" labelRotation="45" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">'
    + '</Axis2DRenderer>'
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    + '<LinearAxis id="vAxis1" formatter="{numfmt}" title="전파Tech지수(%)" labelJsFunction="labelFuncNum"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis2DRenderer axis="{vAxis1}" showLine="false" verticalAxisTitleAlignment="vertical" />'
    + '</verticalAxisRenderers>'
    + '<series>'
    + '<Column2DSeries id="DataSub1" labelPosition="outside" yField="DATA_1_RT" displayName="전파Tech지수(%)" showValueLabels="[]" columnWidthRatio="0.54">'
    + '<fills>';

  for (let i = 0; i < DataSub1.length; i++) {
    if(DataSub1[i].GUBUN_CD===gugunCd){
      layoutStr +='<SolidColor color="red"/>';
    } else {
      layoutStr += '<SolidColor color="#41b2e6"/>';
    }
  }

  layoutStr += '</fills>'
    + '<showDataEffect>'
    + '<SeriesInterpolate/>'
    + '</showDataEffect>'
    + '</Column2DSeries>'
    + '<Line2DSeries radius="6" id="DataSub2" yField="DATA_2_RT" displayName="재정자주도" itemRenderer="CircleItemRenderer">'
    + '<verticalAxis>'
    + '<LinearAxis id="vAxis2" title="재정자주도" labelJsFunction="labelFuncNum" formatter="{numfmt}"/>'
    + '</verticalAxis>'
    + '<showDataEffect>'
    + '<SeriesInterpolate/>'
    + '</showDataEffect>'
    + '<lineStroke>'
    + '<Stroke color="#f9bd03" weight="4"/>'
    + '</lineStroke>'
    + '<stroke>'
    + '<Stroke color="#f9bd03" weight="3"/>'
    + '</stroke>'
    + '<fills>';

  for (let i = 0; i < DataSub2.length; i++) {
    if(DataSub2[i].GUBUN_CD===gugunCd){
      layoutStr +='<SolidColor color="red"/>';
    } else {
      layoutStr += '<SolidColor color="#f9bd03"/>';
    }
  }

  layoutStr += '</fills>'
    + '</Line2DSeries>'
    + '</series>'
    + '<verticalAxisRenderers>'
    + '<Axis2DRenderer axis="{vAxis1}" showLine="false"/>'
    + '<Axis2DRenderer axis="{vAxis2}" showLine="false"/>'
    + '</verticalAxisRenderers>'
    + '<annotationElements>'
    + '<CrossRangeZoomer zoomType="horizontal"  enableZooming="true" enableCrossHair="false">'
    + '</CrossRangeZoomer>'
    + '</annotationElements>'
    + '</Combination2DChart>'
    + '<Style>'
    + '.seriesLabel{fontSize:11;color:#ffffff;fontWeight:bold;}'
    + '.title{color : 0x4691E1;fontSize : 15;fontWeight : bold;}'
    + '</Style>'
    + '</rMateChart>';

  return layoutStr;
}


export function layoutForChart5({ Data, xtitle, ytitle }) {
  // const chartData = Data;

  let layoutStr = '<rMateChart backgroundColor="#FFFFFF"  borderStyle="none">'
    + '<NumberFormatter id="numFmt" precision="0"/>'
    + '<Options>'
    + '<Caption fontSize="15" text="지역별 도시화/전파 지수"/>'
    + '<Legend defaultMouseOverAction="false" useVisibleCheck="true" fontSize="15"/>'
    + '</Options>'
    + '<Column3DChart showDataTips="true" columnWidthRatio="0.56" >'
    + '<horizontalAxis>'
    + '<CategoryAxis id="hAxis" categoryField="GUBUN_NM" title="' + xtitle + '" labelJsFunction="labelFunc"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis3DRenderer axis="{hAxis}" axisTitleStyleName="title" labelRotation="45" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center"/>'
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    + '<LinearAxis id="vAxis" labelJsFunction="labelFuncNum" title="' + ytitle + '"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis}" axisTitleStyleName="title" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical"/>'
    + '</verticalAxisRenderers>'
    + '<series>'
    /* Column3D Multi-Sereis 를 생성시에는 Column3DSeries 여러 개 정의합니다 */
    + '<Column3DSeries id="grad_1" labelPosition="none" yField="SUM_GRAD_1" displayName="도시화 지수" showValueLabels="[3]">'
    + '<fills>';

  for (let i = 0; i < chartBaseData["chart5"].Data.length; i++) {
    if(chartBaseData["chart5"].Data[i].GUBUN_CD===gugunCd){
      layoutStr +='<SolidColor color="red"/>';
    } else {
      layoutStr += '<SolidColor color="#41b2e6"/>';
    }
  }

  layoutStr += '</fills>'
    + '<showDataEffect>'
    + '<SeriesInterpolate/>'
    + '</showDataEffect>'
    + '</Column3DSeries>'
    + '<Column3DSeries id="grad_2" labelPosition="none" yField="SUM_GRAD_2" displayName="전파 지수" showValueLabels="[3]">'
    + '<fills>';

  for (let i = 0; i < chartBaseData["chart5"].Data.length; i++) {
    if(chartBaseData["chart5"].Data[i].GUBUN_CD===gugunCd){
      layoutStr +='<SolidColor color="red"/>';
    } else {
      layoutStr += '<SolidColor color="#4452a8"/>';
    }
  }

  layoutStr += '</fills>'
    + '<showDataEffect>'
    + '<SeriesInterpolate/>'
    + '</showDataEffect>'
    + '</Column3DSeries>'
    + '</series>'
    + '</Column3DChart>'
    + '<Style>'
    + '.seriesLabel{fontSize:11;color:#ffffff;fontWeight:bold;}'
    + '.title{color : 0x4691E1;fontSize : 15;fontWeight : bold;}'
    + '</Style>'
    + '</rMateChart>';

  return layoutStr;
}




export function labelFunc(index, value) {
  return '<font size="12">' + value + '</font>';
  return "";
}

export function labelFuncNum(index, value) {
  return '<font size="12">' + insertComma(value) + '</font>';
  return "";
}

//숫자에 천단위 콤마 찍어 반환하는 함수.
export function insertComma(n) {
  let reg = /(^[+-]?\d+)(\d{3})/; // 정규식
  n += "";
  while (reg.test(n))
    n = n.replace(reg, '$1' + "," + '$2');
  return n;
}

export function dataTipFuncSum(seriesId, seriesName, index, xName, yName, data, values) {
  if (seriesId === "grad_1")
    return "<font style='font-size:12px;'><b>" + data.GUBUN_NM + "</b><br/>도시화 지수 : " + values[1] + "</font>";
  else
    return "<font style='font-size:12px;'><b>" + data.GUBUN_NM + "</b><br/>전파 지수 : " + values[1] + "</font>";
}

export function dataTipFunc2(seriesId, seriesName, index, xName, yName, data, values) {

  for (let i = 0; i < chartBaseData["chart1"].DataSub1.length; i++) {
    let item = chartBaseData["chart1"].DataSub1[i];
    if (data.GUBUN_NM === item.GUBUN_NM) {
      if (seriesId === "avg") {

        const title = "평균 지역발전지수";

        return "<font style='font-size:12px;'><b>" + title + "</b><br/>" + data.GUBUN_NM + " 등급 : " + item.AVG_GRAD + "</font>";
      } else {
        return "<font style='font-size:12px;'>" + data.GUBUN_NM + " 등급 : " + item.GRAD + "</font>";
      }
    }
  }

  return "";

}

export function dataTipFunc2_2(seriesId, seriesName, index, xName, yName, data, values) {
  for (let i = 0; i < chartBaseData["chart2"][seriesId].length; i++) {
    let item = chartBaseData["chart2"][seriesId][i];
    if (data.GUBUN_NM === item.GUBUN_NM) {
      return "<font style='font-size:12px;'><b>" + seriesName + "</b><br/>" + values[0] + " : " + insertComma(Number(values[1]).toFixed(2)) + "</font>";
    }
  }

  return "";

}

export function dataTipFunc2_3(seriesId, seriesName, index, xName, yName, data, values) {
  for (let i = 0; i < chartBaseData["chart3"][seriesId].length; i++) {
    let item = chartBaseData["chart3"][seriesId][i];
    if (data.GUBUN_NM === item.GUBUN_NM) {
      return "<font style='font-size:12px;'><b>" + seriesName + "</b><br/>" + values[0] + " : " + insertComma(Number(values[1]).toFixed(2)) + "</font>";
    }
  }

  return "";

}

export function dataTipFunc2_4(seriesId, seriesName, index, xName, yName, data, values) {
  for (let i = 0; i < chartBaseData["chart4"][seriesId].length; i++) {
    let item = chartBaseData["chart4"][seriesId][i];
    if (data.GUBUN_NM === item.GUBUN_NM) {
      return "<font style='font-size:12px;'><b>" + seriesName + "</b><br/>" + values[0] + " : " + insertComma(Number(values[1]).toFixed(2)) + "</font>";
    }
  }

  return "";

}

/////////////////////////////////////////////////////////////
// Chart 관련 작업 - 끝
/////////////////////////////////////////////////////////////


export function processResponse(itemList, sidoCode, sidoNm, pGugunCd) {
  if(sidoCode)
    sidoGbFirst = sidoCode;
  else
    sidoGbFirst = "";

  if(sidoNm)
    sidoGbNm = sidoNm;
  else
    sidoGbNm = "";

  if(pGugunCd) {
    gugunCd = pGugunCd;
  }
  else {
    gugunCd = "";
  }
  gugunNm = "";

  chartBaseData = window.chartBaseData;
  if(!pGugunCd) {
    chartBaseData["chart1"].Data.length = 0;
    chartBaseData["chart1"].DataSub1.length = 0;
    chartBaseData["chart1"].DataSub2.length = 0;
    chartBaseData["chart1"].Data10.length = 0;

    chartBaseData["chart2"].Data.length = 0;
    chartBaseData["chart2"].DataSub1.length = 0;
    chartBaseData["chart2"].DataSub2.length = 0;
    chartBaseData["chart2"].Data10.length = 0;

    chartBaseData["chart3"].Data.length = 0;
    chartBaseData["chart3"].DataSub1.length = 0;
    chartBaseData["chart3"].DataSub2.length = 0;
    chartBaseData["chart3"].Data10.length = 0;

    chartBaseData["chart4"].Data.length = 0;
    chartBaseData["chart4"].DataSub1.length = 0;
    chartBaseData["chart4"].DataSub2.length = 0;
    chartBaseData["chart4"].Data10.length = 0;

    chartBaseData["chart5"].Data.length = 0;
    chartBaseData["chart5"].DataSub1.length = 0;
    chartBaseData["chart5"].DataSub2.length = 0;
    chartBaseData["chart5"].Data10.length = 0;
  } else {
    chartBaseData["chart1"].Data.length = 0;
    chartBaseData["chart2"].Data.length = 0;
    chartBaseData["chart3"].Data.length = 0;
    chartBaseData["chart4"].Data.length = 0;
    chartBaseData["chart5"].Data.length = 0;
    chartBaseData["chart1"].DataSub1.length = 0;
    chartBaseData["chart1"].DataSub2.length = 0;
  }



  for (let i = 0; i < itemList.length; ++i) {
    let item = itemList[i];
    switch (item.DATA_TYPE) {
      case 'DATA_TYPE1' : // 시가화 지수
        chartBaseData["chart3"].DataSub1.push(item);
        if (sidoGbFirst === "") {
          chartBaseData["chart3"].DataSub11.push(item);
        }
        break;
      case 'DATA_TYPE2' : // 인구비율
        chartBaseData["chart2"].DataSub1.push(item);
        if (sidoGbFirst === "") {
          chartBaseData["chart2"].DataSub11.push(item);
        }
        break;
      case 'DATA_TYPE3' : // 재정자주도
        chartBaseData["chart4"].DataSub2.push(item);
        if (sidoGbFirst === "") {
          chartBaseData["chart4"].DataSub21.push(item);
        }
        break;
      case 'DATA_TYPE4' : // 무선국 자격증 보유자 수
        chartBaseData["chart2"].DataSub2.push(item);
        if (sidoGbFirst === "") {
          chartBaseData["chart2"].DataSub21.push(item);
        }
        break;
      case 'DATA_TYPE5' : // 전파Tech지수
        chartBaseData["chart4"].DataSub1.push(item);
        if (sidoGbFirst === "") {
          chartBaseData["chart4"].DataSub11.push(item);
        }
        break;
      case 'DATA_TYPE6' : // 무선국밀도
        chartBaseData["chart3"].DataSub2.push(item);
        if (sidoGbFirst === "") {
          chartBaseData["chart3"].DataSub21.push(item);
        }
        break;
      // no default
    }
  }



  // SubData로 Data 생성
  let chart1_Data1 = {};
  let chart1_Data2 = {};
  let chart1_Data3 = {};
  let chart1_Data4 = {};
  let chart1_Data5 = {};
  let chart1_Data6 = {};


  chart1_Data1.GUBUN_NM = "인구밀도";
  chart1_Data2.GUBUN_NM = "시가화 지수";
  chart1_Data3.GUBUN_NM = "정보통신 자격현황";
  chart1_Data4.GUBUN_NM = "무선국 밀도";
  chart1_Data5.GUBUN_NM = "전파 Tech지수";
  chart1_Data6.GUBUN_NM = "재정자주도";

  if (chartBaseData["chart2"].DataSub1.length > 0) {
    for (let i = 0; i < chartBaseData["chart2"].DataSub1.length; i++) {
      let tmpData = {};
      tmpData.GUBUN_CD = chartBaseData["chart2"].DataSub1[i].GUBUN_CD;
      tmpData.GUBUN_NM = chartBaseData["chart2"].DataSub1[i].GUBUN_NM;
      tmpData.DATA_1_SIZE = chartBaseData["chart2"].DataSub1[i].CNT;
      tmpData.DATA_1_RT = chartBaseData["chart2"].DataSub1[i].RT;

      if (sidoGbFirst === "") {
        chartBaseData["chart2"].DataSub11[i].GRAD = getGrad(chartBaseData["chart2"].DataSub1[i].MAX_RT, chartBaseData["chart2"].DataSub1[i].RT);
        chartBaseData["chart2"].DataSub11[i].AVG_GRAD = getGrad(chartBaseData["chart2"].DataSub1[i].MAX_RT, chartBaseData["chart2"].DataSub1[i].AVG_RT);
        chartBaseData["chart2"].DataSub1[i].GRAD = getGrad(chartBaseData["chart2"].DataSub1[i].MAX_RT, chartBaseData["chart2"].DataSub1[i].RT);
        chartBaseData["chart2"].DataSub1[i].AVG_GRAD = getGrad(chartBaseData["chart2"].DataSub1[i].MAX_RT, chartBaseData["chart2"].DataSub1[i].AVG_RT);
      } else {
        chartBaseData["chart2"].DataSub1[i].GRAD = getGrad(chartBaseData["chart2"].DataSub1[i].MAX_RT, chartBaseData["chart2"].DataSub1[i].RT);
        chartBaseData["chart2"].DataSub1[i].AVG_GRAD = getGrad(chartBaseData["chart2"].DataSub1[i].MAX_RT, chartBaseData["chart2"].DataSub1[i].AVG_RT);
      }

      tmpData.DATA_2_SIZE = 0;
      tmpData.DATA_2_RT = 0;

      if(tmpData.GUBUN_CD === gugunCd) {
        tmpData.IS_RED = "Y";
      } else {
        tmpData.IS_RED = "N";
      }

      if (sidoGbFirst === "") {
        chart1_Data1.MAXYEAR = chartBaseData["chart2"].DataSub1[i].MAXYEAR;
        chart1_Data1.AVG_RT = chartBaseData["chart2"].DataSub1[i].AVG_RT;
        chart1_Data1.AVG_GRAD = getGrad(chartBaseData["chart2"].DataSub1[i].MAX_RT, chartBaseData["chart2"].DataSub1[i].AVG_RT);
        chart1_Data1.RT = chartBaseData["chart2"].DataSub1[i].RT;
      } else {
        for(let j = 0; j < chartBaseData["chart2"].DataSub11.length; j++) {
          if (chartBaseData["chart2"].DataSub11[j].GUBUN_CD.substr(0, 2) === sidoGbFirst) {
            chart1_Data1.MAXYEAR = chartBaseData["chart2"].DataSub11[j].MAXYEAR;
            chart1_Data1.AVG_RT = chartBaseData["chart2"].DataSub11[j].AVG_RT;
            chart1_Data1.RT = chartBaseData["chart2"].DataSub11[j].RT;
            chart1_Data1.GRAD = getGrad(chartBaseData["chart2"].DataSub11[j].MAX_RT, chartBaseData["chart2"].DataSub11[j].RT);
            chart1_Data1.AVG_GRAD = getGrad(chartBaseData["chart2"].DataSub11[j].MAX_RT, chartBaseData["chart2"].DataSub11[j].AVG_RT);
          }
        }
        if (chartBaseData["chart2"].DataSub1[i].GUBUN_CD === gugunCd) {
          chart1_Data1.DTL_GRAD = getGrad(chartBaseData["chart2"].DataSub1[i].MAX_RT, chartBaseData["chart2"].DataSub1[i].RT);
          if(!gugunNm) gugunNm = chartBaseData["chart2"].DataSub1[i].GUBUN_NM;
        }
      }
      if (chartBaseData["chart2"].DataSub2.length > 0) {
        for (let j = 0; j < chartBaseData["chart2"].DataSub2.length; j++) {
          if (tmpData.GUBUN_CD === chartBaseData["chart2"].DataSub2[j].GUBUN_CD) {
            tmpData.DATA_2_SIZE = chartBaseData["chart2"].DataSub2[j].CNT;
            tmpData.DATA_2_RT = chartBaseData["chart2"].DataSub2[j].RT;
            chartBaseData["chart2"].Data.push(tmpData);
          }
        }
      }

    }
    if (chartBaseData["chart2"].DataSub2.length > 0) {
      for (let i = 0; i < chartBaseData["chart2"].DataSub2.length; i++) {
        if (sidoGbFirst === "") {
          chartBaseData["chart2"].DataSub21[i].GRAD = getGrad(chartBaseData["chart2"].DataSub2[i].MAX_RT, chartBaseData["chart2"].DataSub2[i].RT);
          chartBaseData["chart2"].DataSub21[i].AVG_GRAD = getGrad(chartBaseData["chart2"].DataSub2[i].MAX_RT, chartBaseData["chart2"].DataSub2[i].AVG_RT);
          chartBaseData["chart2"].DataSub2[i].GRAD = getGrad(chartBaseData["chart2"].DataSub2[i].MAX_RT, chartBaseData["chart2"].DataSub2[i].RT);
          chartBaseData["chart2"].DataSub2[i].AVG_GRAD = getGrad(chartBaseData["chart2"].DataSub2[i].MAX_RT, chartBaseData["chart2"].DataSub2[i].AVG_RT);
        } else {
          chartBaseData["chart2"].DataSub2[i].GRAD = getGrad(chartBaseData["chart2"].DataSub2[i].MAX_RT, chartBaseData["chart2"].DataSub2[i].RT);
          chartBaseData["chart2"].DataSub2[i].AVG_GRAD = getGrad(chartBaseData["chart2"].DataSub2[i].MAX_RT, chartBaseData["chart2"].DataSub2[i].AVG_RT);
        }

        if (sidoGbFirst === "") {
          chart1_Data3.MAXYEAR = chartBaseData["chart2"].DataSub2[i].MAXYEAR;
          chart1_Data3.AVG_RT = chartBaseData["chart2"].DataSub2[i].AVG_RT;
          chart1_Data3.AVG_GRAD = getGrad(chartBaseData["chart2"].DataSub2[i].MAX_RT, chartBaseData["chart2"].DataSub2[i].AVG_RT);
          chart1_Data3.RT = chartBaseData["chart2"].DataSub2[i].RT;
        } else {
          for(let j = 0; j < chartBaseData["chart2"].DataSub21.length; j++) {
            if (chartBaseData["chart2"].DataSub21[j].GUBUN_CD.substr(0, 2) === sidoGbFirst) {
              chart1_Data3.MAXYEAR = chartBaseData["chart2"].DataSub21[j].MAXYEAR;
              chart1_Data3.AVG_RT = chartBaseData["chart2"].DataSub21[j].AVG_RT;
              chart1_Data3.RT = chartBaseData["chart2"].DataSub21[j].RT;
              chart1_Data3.GRAD = getGrad(chartBaseData["chart2"].DataSub21[j].MAX_RT, chartBaseData["chart2"].DataSub21[j].RT);
              chart1_Data3.AVG_GRAD = getGrad(chartBaseData["chart2"].DataSub21[j].MAX_RT, chartBaseData["chart2"].DataSub21[j].AVG_RT);
            }
          }
          if (chartBaseData["chart2"].DataSub2[i].GUBUN_CD === gugunCd) {
            chart1_Data3.DTL_GRAD = getGrad(chartBaseData["chart2"].DataSub2[i].MAX_RT, chartBaseData["chart2"].DataSub2[i].RT);
            if(!gugunNm) gugunNm = chartBaseData["chart2"].DataSub2[i].GUBUN_NM;
          }
        }
      }
    }
  }




  if (chartBaseData["chart3"].DataSub2.length > 0) {

    for (let i = 0; i < chartBaseData["chart3"].DataSub2.length; i++) {
      let tmpData = {};
      tmpData.GUBUN_CD = chartBaseData["chart3"].DataSub2[i].GUBUN_CD;
      tmpData.GUBUN_NM = chartBaseData["chart3"].DataSub2[i].GUBUN_NM;
      tmpData.DATA_2_SIZE = chartBaseData["chart3"].DataSub2[i].SIZE;
      tmpData.DATA_2_RT = chartBaseData["chart3"].DataSub2[i].RT;

      if (sidoGbFirst === "") {
        chartBaseData["chart3"].DataSub21[i].GRAD = getGrad(chartBaseData["chart3"].DataSub2[i].MAX_RT, chartBaseData["chart3"].DataSub2[i].RT);
        chartBaseData["chart3"].DataSub21[i].AVG_GRAD = getGrad(chartBaseData["chart3"].DataSub2[i].MAX_RT, chartBaseData["chart3"].DataSub2[i].AVG_RT);
        chartBaseData["chart3"].DataSub2[i].GRAD = getGrad(chartBaseData["chart3"].DataSub2[i].MAX_RT, chartBaseData["chart3"].DataSub2[i].RT);
        chartBaseData["chart3"].DataSub2[i].AVG_GRAD = getGrad(chartBaseData["chart3"].DataSub2[i].MAX_RT, chartBaseData["chart3"].DataSub2[i].AVG_RT);
      } else {
        chartBaseData["chart3"].DataSub2[i].GRAD = getGrad(chartBaseData["chart3"].DataSub2[i].MAX_RT, chartBaseData["chart3"].DataSub2[i].RT);
        chartBaseData["chart3"].DataSub2[i].AVG_GRAD = getGrad(chartBaseData["chart3"].DataSub2[i].MAX_RT, chartBaseData["chart3"].DataSub2[i].AVG_RT);
      }


      tmpData.DATA_1_SIZE = 0;
      tmpData.DATA_1_RT = 0;

      if(tmpData.GUBUN_CD === gugunCd) {
        tmpData.IS_RED = "Y";
      } else {
        tmpData.IS_RED = "N";
      }

      if (sidoGbFirst === "") {
        chart1_Data4.MAXYEAR = chartBaseData["chart3"].DataSub2[i].MAXYEAR;
        chart1_Data4.AVG_RT = chartBaseData["chart3"].DataSub2[i].AVG_RT;
        chart1_Data4.AVG_GRAD = getGrad(chartBaseData["chart3"].DataSub2[i].MAX_RT, chartBaseData["chart3"].DataSub2[i].AVG_RT);
        chart1_Data4.RT = chartBaseData["chart3"].DataSub2[i].RT;
      } else {
        for(let j = 0; j < chartBaseData["chart3"].DataSub21.length; j++) {
          if (chartBaseData["chart3"].DataSub21[j].GUBUN_CD.substr(0, 2) === sidoGbFirst) {
            chart1_Data4.MAXYEAR = chartBaseData["chart3"].DataSub21[j].MAXYEAR;
            chart1_Data4.AVG_RT = chartBaseData["chart3"].DataSub21[j].AVG_RT;
            chart1_Data4.RT = chartBaseData["chart3"].DataSub21[j].RT;
            chart1_Data4.GRAD = getGrad(chartBaseData["chart3"].DataSub21[j].MAX_RT, chartBaseData["chart3"].DataSub21[j].RT);
            chart1_Data4.AVG_GRAD = getGrad(chartBaseData["chart3"].DataSub21[j].MAX_RT, chartBaseData["chart3"].DataSub21[j].AVG_RT);
          }
        }
        if (chartBaseData["chart3"].DataSub2[i].GUBUN_CD === gugunCd) {
          chart1_Data4.DTL_GRAD = getGrad(chartBaseData["chart3"].DataSub2[i].MAX_RT, chartBaseData["chart3"].DataSub2[i].RT);
          if(!gugunNm) gugunNm = chartBaseData["chart3"].DataSub2[i].GUBUN_NM;
        }
      }
      if (chartBaseData["chart3"].DataSub1.length > 0) {
        for (let j = 0; j < chartBaseData["chart3"].DataSub1.length; j++) {
          if (tmpData.GUBUN_CD === chartBaseData["chart3"].DataSub1[j].GUBUN_CD) {
            tmpData.DATA_1_SIZE = chartBaseData["chart3"].DataSub1[j].SIZE;
            tmpData.DATA_1_RT = chartBaseData["chart3"].DataSub1[j].RT;
            chartBaseData["chart3"].Data.push(tmpData);
          }
        }
      }
    }
    if (chartBaseData["chart3"].DataSub1.length > 0) {
      for (let i = 0; i < chartBaseData["chart3"].DataSub1.length; i++) {
        if (sidoGbFirst === "") {
          chartBaseData["chart3"].DataSub11[i].GRAD = getGrad(chartBaseData["chart3"].DataSub1[i].MAX_RT, chartBaseData["chart3"].DataSub1[i].RT);
          chartBaseData["chart3"].DataSub11[i].AVG_GRAD = getGrad(chartBaseData["chart3"].DataSub1[i].MAX_RT, chartBaseData["chart3"].DataSub1[i].AVG_RT);
          chartBaseData["chart3"].DataSub1[i].GRAD = getGrad(chartBaseData["chart3"].DataSub1[i].MAX_RT, chartBaseData["chart3"].DataSub1[i].RT);
          chartBaseData["chart3"].DataSub1[i].AVG_GRAD = getGrad(chartBaseData["chart3"].DataSub1[i].MAX_RT, chartBaseData["chart3"].DataSub1[i].AVG_RT);
        } else {
          chartBaseData["chart3"].DataSub1[i].GRAD = getGrad(chartBaseData["chart3"].DataSub1[i].MAX_RT, chartBaseData["chart3"].DataSub1[i].RT);
          chartBaseData["chart3"].DataSub1[i].AVG_GRAD = getGrad(chartBaseData["chart3"].DataSub1[i].MAX_RT, chartBaseData["chart3"].DataSub1[i].AVG_RT);
        }

        if (sidoGbFirst === "") {
          chart1_Data2.MAXYEAR = chartBaseData["chart3"].DataSub1[i].MAXYEAR;
          chart1_Data2.AVG_RT = chartBaseData["chart3"].DataSub1[i].AVG_RT;
          chart1_Data2.AVG_GRAD = getGrad(chartBaseData["chart3"].DataSub1[i].MAX_RT, chartBaseData["chart3"].DataSub1[i].AVG_RT);
          chart1_Data2.RT = chartBaseData["chart3"].DataSub1[i].RT;
        } else {
          for(let j = 0; j < chartBaseData["chart3"].DataSub11.length; j++) {
            if (chartBaseData["chart3"].DataSub11[j].GUBUN_CD.substr(0, 2) === sidoGbFirst) {
              chart1_Data2.MAXYEAR = chartBaseData["chart3"].DataSub11[j].MAXYEAR;
              chart1_Data2.AVG_RT = chartBaseData["chart3"].DataSub11[j].AVG_RT;
              chart1_Data2.RT = chartBaseData["chart3"].DataSub11[j].RT;
              chart1_Data2.GRAD = getGrad(chartBaseData["chart3"].DataSub11[j].MAX_RT, chartBaseData["chart3"].DataSub11[j].RT);
              chart1_Data2.AVG_GRAD = getGrad(chartBaseData["chart3"].DataSub11[j].MAX_RT, chartBaseData["chart3"].DataSub11[j].AVG_RT);
            }
          }
          if (chartBaseData["chart3"].DataSub1[i].GUBUN_CD === gugunCd) {
            chart1_Data2.DTL_GRAD = getGrad(chartBaseData["chart3"].DataSub1[i].MAX_RT, chartBaseData["chart3"].DataSub1[i].RT);
            if(!gugunNm) gugunNm = chartBaseData["chart3"].DataSub1[i].GUBUN_NM;
          }
        }
      }
    }
  }



  if (chartBaseData["chart4"].DataSub1.length > 0) {
    for (let i = 0; i < chartBaseData["chart4"].DataSub1.length; i++) {
      let tmpData = {};
      tmpData.GUBUN_CD = chartBaseData["chart4"].DataSub1[i].GUBUN_CD;
      tmpData.GUBUN_NM = chartBaseData["chart4"].DataSub1[i].GUBUN_NM;
      tmpData.DATA_1_SIZE = chartBaseData["chart4"].DataSub1[i].SIZE;
      tmpData.DATA_1_RT = chartBaseData["chart4"].DataSub1[i].RT;

      if (sidoGbFirst === "") {
        chartBaseData["chart4"].DataSub1[i].GRAD = getGrad(chartBaseData["chart4"].DataSub1[i].MAX_RT, chartBaseData["chart4"].DataSub1[i].RT);
        chartBaseData["chart4"].DataSub1[i].AVG_GRAD = getGrad(chartBaseData["chart4"].DataSub1[i].MAX_RT, chartBaseData["chart4"].DataSub1[i].AVG_RT);
        chartBaseData["chart4"].DataSub11[i].GRAD = getGrad(chartBaseData["chart4"].DataSub1[i].MAX_RT, chartBaseData["chart4"].DataSub1[i].RT);
        chartBaseData["chart4"].DataSub11[i].AVG_GRAD = getGrad(chartBaseData["chart4"].DataSub1[i].MAX_RT, chartBaseData["chart4"].DataSub1[i].AVG_RT);
      } else {
        chartBaseData["chart4"].DataSub1[i].GRAD = getGrad(chartBaseData["chart4"].DataSub1[i].MAX_RT, chartBaseData["chart4"].DataSub1[i].RT);
        chartBaseData["chart4"].DataSub1[i].AVG_GRAD = getGrad(chartBaseData["chart4"].DataSub1[i].MAX_RT, chartBaseData["chart4"].DataSub1[i].AVG_RT);
      }


      tmpData.DATA_2_SIZE = 0;
      tmpData.DATA_2_RT = 0;

      if(tmpData.GUBUN_CD === gugunCd) {
        tmpData.IS_RED = "Y";
      } else {
        tmpData.IS_RED = "N";
      }


      if (sidoGbFirst === "") {
        chart1_Data5.MAXYEAR = chartBaseData["chart4"].DataSub1[i].MAXYEAR;
        chart1_Data5.AVG_RT = chartBaseData["chart4"].DataSub1[i].AVG_RT;
        chart1_Data5.AVG_GRAD = getGrad(chartBaseData["chart4"].DataSub1[i].MAX_RT, chartBaseData["chart4"].DataSub1[i].AVG_RT);
        chart1_Data5.RT = chartBaseData["chart4"].DataSub1[i].RT;
      } else {
        for(let j = 0; j < chartBaseData["chart4"].DataSub11.length; j++) {
          if (chartBaseData["chart4"].DataSub11[j].GUBUN_CD.substr(0, 2) === sidoGbFirst) {
            chart1_Data5.MAXYEAR = chartBaseData["chart4"].DataSub11[j].MAXYEAR;
            chart1_Data5.AVG_RT = chartBaseData["chart4"].DataSub11[j].AVG_RT;
            chart1_Data5.RT = chartBaseData["chart4"].DataSub11[j].RT;
            chart1_Data5.GRAD = getGrad(chartBaseData["chart4"].DataSub11[j].MAX_RT, chartBaseData["chart4"].DataSub11[j].RT);
            chart1_Data5.AVG_GRAD = getGrad(chartBaseData["chart4"].DataSub11[j].MAX_RT, chartBaseData["chart4"].DataSub11[j].AVG_RT);
          }
        }
        if (chartBaseData["chart4"].DataSub1[i].GUBUN_CD === gugunCd) {
          chart1_Data5.DTL_GRAD = getGrad(chartBaseData["chart4"].DataSub1[i].MAX_RT, chartBaseData["chart4"].DataSub1[i].RT);
          if(!gugunNm) gugunNm = chartBaseData["chart4"].DataSub1[i].GUBUN_NM;
        }
      }
      if (chartBaseData["chart4"].DataSub2.length > 0) {
        for (let j = 0; j < chartBaseData["chart4"].DataSub2.length; j++) {
          if (tmpData.GUBUN_CD === chartBaseData["chart4"].DataSub2[j].GUBUN_CD) {
            tmpData.DATA_2_SIZE = chartBaseData["chart4"].DataSub2[j].SIZE;
            tmpData.DATA_2_RT = chartBaseData["chart4"].DataSub2[j].RT;
            chartBaseData["chart4"].Data.push(tmpData);
          }
        }
      }
    }
    if (chartBaseData["chart4"].DataSub2.length > 0) {
      for (let i = 0; i < chartBaseData["chart4"].DataSub2.length; i++) {
        if (sidoGbFirst === "") {
          chartBaseData["chart4"].DataSub2[i].GRAD = getGrad(chartBaseData["chart4"].DataSub2[i].MAX_RT, chartBaseData["chart4"].DataSub2[i].RT);
          chartBaseData["chart4"].DataSub2[i].AVG_GRAD = getGrad(chartBaseData["chart4"].DataSub2[i].MAX_RT, chartBaseData["chart4"].DataSub2[i].AVG_RT);
          chartBaseData["chart4"].DataSub21[i].GRAD = getGrad(chartBaseData["chart4"].DataSub2[i].MAX_RT, chartBaseData["chart4"].DataSub2[i].RT);
          chartBaseData["chart4"].DataSub21[i].AVG_GRAD = getGrad(chartBaseData["chart4"].DataSub2[i].MAX_RT, chartBaseData["chart4"].DataSub2[i].AVG_RT);
        } else {
          chartBaseData["chart4"].DataSub2[i].GRAD = getGrad(chartBaseData["chart4"].DataSub2[i].MAX_RT, chartBaseData["chart4"].DataSub2[i].RT);
          chartBaseData["chart4"].DataSub2[i].AVG_GRAD = getGrad(chartBaseData["chart4"].DataSub2[i].MAX_RT, chartBaseData["chart4"].DataSub2[i].AVG_RT);
        }

        if (sidoGbFirst === "") {
          chart1_Data6.MAXYEAR = chartBaseData["chart4"].DataSub2[i].MAXYEAR;
          chart1_Data6.AVG_RT = chartBaseData["chart4"].DataSub2[i].AVG_RT;
          chart1_Data6.AVG_GRAD = getGrad(chartBaseData["chart4"].DataSub2[i].MAX_RT, chartBaseData["chart4"].DataSub2[i].AVG_RT);
          chart1_Data6.RT = chartBaseData["chart4"].DataSub2[i].RT;

        } else {
          for(let j = 0; j < chartBaseData["chart4"].DataSub21.length; j++) {
            if (chartBaseData["chart4"].DataSub21[j].GUBUN_CD.substr(0, 2) === sidoGbFirst) {
              chart1_Data6.MAXYEAR = chartBaseData["chart4"].DataSub21[j].MAXYEAR;
              chart1_Data6.AVG_RT = chartBaseData["chart4"].DataSub21[j].AVG_RT;
              chart1_Data6.RT = chartBaseData["chart4"].DataSub21[j].RT;
              chart1_Data6.GRAD = getGrad(chartBaseData["chart4"].DataSub21[j].MAX_RT, chartBaseData["chart4"].DataSub21[j].RT);
              chart1_Data6.AVG_GRAD = getGrad(chartBaseData["chart4"].DataSub21[j].MAX_RT, chartBaseData["chart4"].DataSub21[j].AVG_RT);
            }
            if (chartBaseData["chart4"].DataSub2[i].GUBUN_CD === gugunCd) {
              chart1_Data6.DTL_GRAD = getGrad(chartBaseData["chart4"].DataSub2[i].MAX_RT, chartBaseData["chart4"].DataSub2[i].RT);
              if(!gugunNm) gugunNm = chartBaseData["chart4"].DataSub2[i].GUBUN_NM;
            }
          }
        }
      }
    }
  }

  let sumTableHtml = '<caption>전국 시도 평균 지역 발전 지수</caption><colgroup><col width="15%"><col width="35%"><col width="25%"><col width="25%"></colgroup>';
  // $("#sumTable").html('');
  sumTableHtml += "<thead>";
  sumTableHtml += "<tr>";
  sumTableHtml += "<th scope=\"colgroup\" class=\"text_c\" colspan=\"2\" rowspan=\"2\" style=\"background:#f8f8f8;font-size:12px;border-right:1px solid #dedede;\">구분</th>";
  sumTableHtml += "<th scope=\"colgroup\" class=\"text_c\" colspan=\"2\" style=\"background:#f8f8f8;font-size:12px;text-align:center;\"></th>";
  sumTableHtml += "</tr>";

  sumTableHtml += "<tr>";
  sumTableHtml += "<th scope=\"col\" class=\"text_c\" style=\"background:#f8f8f8;font-size:12px;text-align:center;border-right:1px solid #dedede;\">수치</th>";
  sumTableHtml += "<th scope=\"col\" class=\"text_c\" style=\"background:#f8f8f8;font-size:12px;text-align:center;\">등급</th>";
  sumTableHtml += "</tr>";
  sumTableHtml += "</thead>";

  chartBaseData["chart1"].Data.push(chart1_Data1);
  chartBaseData["chart1"].DataSub1.push(chart1_Data1);
  chartBaseData["chart1"].DataSub2.push(chart1_Data1);
  sumTableHtml += "<tr>";
  sumTableHtml += "<td scope=\"row\" class=\"text_c\" style=\"background:#f8f8f8;font-size:12px;\" rowspan=\"3\">전파</td>";
  sumTableHtml += "<td scope=\"row\" class=\"text_c\" style=\"background:#f8f8f8;font-size:12px;\">" + chart1_Data4.GUBUN_NM + " ( " + chart1_Data4.MAXYEAR + " )" + "</td>";
  sumTableHtml += "<td class=\"text_r pdr15\" style=\"font-size:12px;border-right:1px solid #dedede;\">" + insertComma(Number(chart1_Data4.AVG_RT).toFixed(1)) + "</td>";
  sumTableHtml += "<td class=\"text_r pdr15\" style=\"font-size:12px;\">" + chart1_Data4.AVG_GRAD + "</td>";
  sumTableHtml += "</tr>";

  chartBaseData["chart1"].Data.push(chart1_Data2);
  chartBaseData["chart1"].DataSub1.push(chart1_Data2);
  chartBaseData["chart1"].DataSub2.push(chart1_Data2);
  sumTableHtml += "<tr>";
  sumTableHtml += "<td scope=\"row\" class=\"text_c\" style=\"background:#f8f8f8;font-size:12px;\">" + chart1_Data5.GUBUN_NM + " ( " + chart1_Data5.MAXYEAR + " )" + "</td>";
  sumTableHtml += "<td class=\"text_r pdr15\" style=\"font-size:12px;border-right:1px solid #dedede;\">" + insertComma(Number(chart1_Data5.AVG_RT).toFixed(1)) + "</td>";
  sumTableHtml += "<td class=\"text_r pdr15\" style=\"font-size:12px;\">" + chart1_Data5.AVG_GRAD + "</td>";
  sumTableHtml += "</tr>";

  chartBaseData["chart1"].Data.push(chart1_Data3);
  chartBaseData["chart1"].DataSub1.push(chart1_Data3);
  chartBaseData["chart1"].DataSub2.push(chart1_Data3);
  sumTableHtml += "<tr>";
  sumTableHtml += "<td scope=\"row\" class=\"text_c\" style=\"background:#f8f8f8;font-size:12px;\">" + chart1_Data3.GUBUN_NM + " ( " + chart1_Data3.MAXYEAR + " )" + "</td>";
  sumTableHtml += "<td class=\"text_r pdr15\" style=\"font-size:12px;border-right:1px solid #dedede;\">" + insertComma(Number(chart1_Data3.AVG_RT).toFixed(1)) + "</td>";
  sumTableHtml += "<td class=\"text_r pdr15\" style=\"font-size:12px;\">" + chart1_Data3.AVG_GRAD + "</td>";
  sumTableHtml += "</tr>";

  chartBaseData["chart1"].Data.push(chart1_Data4);
  chartBaseData["chart1"].DataSub1.push(chart1_Data4);
  chartBaseData["chart1"].DataSub2.push(chart1_Data4);
  sumTableHtml += "<tr>";
  sumTableHtml += "<td scope=\"row\" class=\"text_c\" style=\"background:#f8f8f8;font-size:12px;\" rowspan=\"3\">도시화</td>";
  sumTableHtml += "<td scope=\"row\" class=\"text_c\" style=\"background:#f8f8f8;font-size:12px;\">" + chart1_Data6.GUBUN_NM + " ( " + chart1_Data6.MAXYEAR + " )" + "</td>";
  sumTableHtml += "<td class=\"text_r pdr15\" style=\"font-size:12px;border-right:1px solid #dedede;\">" + insertComma(Number(chart1_Data6.AVG_RT).toFixed(1)) + "</td>";
  sumTableHtml += "<td class=\"text_r pdr15\" style=\"font-size:12px;\">" + chart1_Data6.AVG_GRAD + "</td>";
  sumTableHtml += "</tr>";

  chartBaseData["chart1"].Data.push(chart1_Data5);
  chartBaseData["chart1"].DataSub1.push(chart1_Data5);
  chartBaseData["chart1"].DataSub2.push(chart1_Data5);
  sumTableHtml += "<tr>";
  sumTableHtml += "<td scope=\"row\" class=\"text_c\" style=\"background:#f8f8f8;font-size:12px;\">" + chart1_Data1.GUBUN_NM + " ( " + chart1_Data1.MAXYEAR + " )" + "</td>";
  sumTableHtml += "<td class=\"text_r pdr15\" style=\"font-size:12px;border-right:1px solid #dedede;\">" + insertComma(Number(chart1_Data1.AVG_RT).toFixed(1)) + "</td>";
  sumTableHtml += "<td class=\"text_r pdr15\" style=\"font-size:12px;\">" + chart1_Data1.AVG_GRAD + "</td>";
  sumTableHtml += "</tr>";

  chartBaseData["chart1"].Data.push(chart1_Data6);
  chartBaseData["chart1"].DataSub1.push(chart1_Data6);
  chartBaseData["chart1"].DataSub2.push(chart1_Data6);
  sumTableHtml += "<tr>";
  sumTableHtml += "<td scope=\"row\" class=\"text_c\" style=\"background:#f8f8f8;font-size:12px;\">" + chart1_Data2.GUBUN_NM + " ( " + chart1_Data2.MAXYEAR + " )" + "</td>";
  sumTableHtml += "<td class=\"text_r pdr15\" style=\"font-size:12px;border-right:1px solid #dedede;\">" + insertComma(Number(chart1_Data2.AVG_RT).toFixed(1)) + "</td>";
  sumTableHtml += "<td class=\"text_r pdr15\" style=\"font-size:12px;\">" + chart1_Data2.AVG_GRAD + "</td>";
  sumTableHtml += "</tr>";
  // $("#sumTable").html(sumTableHtml);

  let sumAVG_GRAD = chart1_Data1.AVG_GRAD + chart1_Data2.AVG_GRAD + chart1_Data3.AVG_GRAD + chart1_Data4.AVG_GRAD + chart1_Data5.AVG_GRAD + chart1_Data6.AVG_GRAD;

  sumTableHtml += "<tr>";
  sumTableHtml += "<td scope=\"row\" class=\"text_c\" colspan=\"2\" style=\"background:#f8f8f8;font-size:12px;\">합계</td>";
  sumTableHtml += "<td class=\"text_r pdr15\" style=\"font-size:12px;border-right:1px solid #dedede;\"></td>";
  sumTableHtml += "<td class=\"text_r pdr15\" style=\"font-size:12px;\">" + sumAVG_GRAD + "</td>";
  sumTableHtml += "</tr>";
  // $("#sumTable").html(sumTableHtml);

  let legendAry = new Array();

  if (chartBaseData["chart2"].DataSub1.length > 0) {
    for (let i = 0; i < chartBaseData["chart2"].DataSub1.length; i++) {
      let legendData = {};
      legendData.GUBUN_CD = chartBaseData["chart2"].DataSub1[i].GUBUN_CD;
      legendData.GUBUN_NM = chartBaseData["chart2"].DataSub1[i].GUBUN_NM;
      legendData.DATA_1_RT = chartBaseData["chart2"].DataSub1[i].RT;
      legendAry.push(legendData);
    }
  }

  if (chartBaseData["chart2"].DataSub2.length > 0) {
    for (let i = 0; i < chartBaseData["chart2"].DataSub2.length; i++) {

      for (let j = 0; j < legendAry.length; j++) {
        if (legendAry[j].GUBUN_CD === chartBaseData["chart2"].DataSub2[i].GUBUN_CD) {
          legendAry[j].DATA_2_RT = chartBaseData["chart2"].DataSub2[i].RT;
        }
      }
    }
  }

  if (chartBaseData["chart3"].DataSub1.length > 0) {
    for (let i = 0; i < chartBaseData["chart3"].DataSub1.length; i++) {

      for (let j = 0; j < legendAry.length; j++) {
        if (legendAry[j].GUBUN_CD === chartBaseData["chart3"].DataSub1[i].GUBUN_CD) {
          legendAry[j].DATA_3_RT = chartBaseData["chart3"].DataSub1[i].RT;
        }
      }
    }
  }

  if (chartBaseData["chart3"].DataSub2.length > 0) {
    for (let i = 0; i < chartBaseData["chart3"].DataSub2.length; i++) {
      for (let j = 0; j < legendAry.length; j++) {
        if (legendAry[j].GUBUN_CD === chartBaseData["chart3"].DataSub2[i].GUBUN_CD) {
          legendAry[j].DATA_4_RT = chartBaseData["chart3"].DataSub2[i].RT;
        }
      }
    }
  }

  if (chartBaseData["chart4"].DataSub1.length > 0) {
    for (let i = 0; i < chartBaseData["chart4"].DataSub1.length; i++) {
      for (let j = 0; j < legendAry.length; j++) {
        if (legendAry[j].GUBUN_CD === chartBaseData["chart4"].DataSub1[i].GUBUN_CD) {
          legendAry[j].DATA_5_RT = chartBaseData["chart4"].DataSub1[i].RT;
        }
      }
    }
  }

  if (chartBaseData["chart4"].DataSub2.length > 0) {
    for (let i = 0; i < chartBaseData["chart4"].DataSub2.length; i++) {
      for (let j = 0; j < legendAry.length; j++) {
        if (legendAry[j].GUBUN_CD === chartBaseData["chart4"].DataSub2[i].GUBUN_CD) {
          legendAry[j].DATA_6_RT = chartBaseData["chart4"].DataSub2[i].RT;
        }
      }
    }
  }

  gridshowJsonDataList();

  chartBaseData["chart2"].Data.sort(function (a, b) {
    return (b.DATA_1_SIZE + b.DATA_2_SIZE) - (a.DATA_1_SIZE + a.DATA_2_SIZE);
  });

  chartBaseData["chart3"].Data.sort(function (a, b) {
    return (b.DATA_1_RT + b.DATA_2_RT) - (a.DATA_1_RT + a.DATA_2_RT);
  });

  chartBaseData["chart4"].Data.sort(function (a, b) {
    return (b.DATA_1_RT + b.DATA_2_RT) - (a.DATA_1_RT + a.DATA_2_RT);
  });

  chartBaseData["chart5"].Data.sort(function (a, b) {
    return b.SUM_GRAD - a.SUM_GRAD;
  });

  return chartBaseData;
}

export function getGrad(maxVal, nowVal) {
  let lengArray = new Array();
  if(maxVal===null || maxVal===undefined || nowVal ===null || nowVal===undefined) return null;

  let legenVal = (Math.floor(Number(maxVal)/9*100)/100).toFixed(2);

  for(let i=0; i < 10; i++){
    lengArray[i] = Math.floor((legenVal * i*100))/100;
  }
  for(let i=9; i >= 0; i--){
    if(nowVal === 0){
      return 0;
    } else {
      if(nowVal >= lengArray[i]){
        return (i+1);
      }
    }
  }
  return 0;
}

export function gridshowJsonDataList() {

  let tmpData = {};

  tmpData.GUBUN_NM = '';
  tmpData.SUM_GRAD = 0;

  if (chartBaseData["chart3"].DataSub2.length > 0) {

    tmpData.DATA_1_RT = chartBaseData["chart3"].DataSub2[0].AVG_RT;
    tmpData.DATA_1_GRAD = chartBaseData["chart3"].DataSub2[0].AVG_GRAD;
    tmpData.SUM_GRAD += tmpData.DATA_1_GRAD;
  }

  if (chartBaseData["chart4"].DataSub1.length > 0) {

    tmpData.DATA_2_RT = chartBaseData["chart4"].DataSub1[0].AVG_RT;
    tmpData.DATA_2_GRAD = chartBaseData["chart4"].DataSub1[0].AVG_GRAD;
    tmpData.SUM_GRAD += tmpData.DATA_2_GRAD;
  }

  if (chartBaseData["chart2"].DataSub2.length > 0) {
    tmpData.DATA_3_RT = chartBaseData["chart2"].DataSub2[0].AVG_RT;
    tmpData.DATA_3_GRAD = chartBaseData["chart2"].DataSub2[0].AVG_GRAD;
    tmpData.SUM_GRAD += tmpData.DATA_3_GRAD;
  }

  if (chartBaseData["chart4"].DataSub2.length > 0) {
    tmpData.DATA_4_RT = chartBaseData["chart4"].DataSub2[0].AVG_RT;
    tmpData.DATA_4_GRAD = chartBaseData["chart4"].DataSub2[0].AVG_GRAD;
    tmpData.SUM_GRAD += tmpData.DATA_4_GRAD;
  }

  if (chartBaseData["chart2"].DataSub1.length > 0) {
    tmpData.DATA_5_RT = chartBaseData["chart2"].DataSub1[0].AVG_RT;
    tmpData.DATA_5_GRAD = chartBaseData["chart2"].DataSub1[0].AVG_GRAD;
    tmpData.SUM_GRAD += tmpData.DATA_5_GRAD;
  }

  if (chartBaseData["chart3"].DataSub1.length > 0) {

    tmpData.DATA_6_RT = chartBaseData["chart3"].DataSub1[0].AVG_RT;
    tmpData.DATA_6_GRAD = chartBaseData["chart3"].DataSub1[0].AVG_GRAD;
    tmpData.SUM_GRAD += tmpData.DATA_6_GRAD;
  }


  for (let i = 0; i < chartBaseData["chart3"].DataSub2.length; i++) {
    tmpData = {};
    tmpData.SUM_GRAD_1 = 0;
    tmpData.SUM_GRAD_2 = 0;

    tmpData.GUBUN_CD = chartBaseData["chart3"].DataSub2[i].GUBUN_CD;
    tmpData.GUBUN_NM = chartBaseData["chart3"].DataSub2[i].GUBUN_NM;

    if(tmpData.GUBUN_CD === gugunCd) {
      tmpData.IS_RED = "Y";
    } else {
      tmpData.IS_RED = "N";
    }

    tmpData.DATA_1_RT = chartBaseData["chart3"].DataSub2[i].RT;
    tmpData.DATA_1_GRAD = chartBaseData["chart3"].DataSub2[i].GRAD;
    tmpData.SUM_GRAD_1 += parseInt(tmpData.DATA_1_GRAD);



    for (let j = 0; j < chartBaseData["chart4"].DataSub1.length; j++) {
      if (tmpData.GUBUN_CD === chartBaseData["chart4"].DataSub1[j].GUBUN_CD) {

        tmpData.DATA_2_RT = chartBaseData["chart4"].DataSub1[i].RT;
        tmpData.DATA_2_GRAD = chartBaseData["chart4"].DataSub1[i].GRAD;
        tmpData.SUM_GRAD_2 += parseInt(tmpData.DATA_2_GRAD);
        break;
      }
    }

    for (let j = 0; j < chartBaseData["chart2"].DataSub2.length; j++) {
      if (tmpData.GUBUN_CD === chartBaseData["chart2"].DataSub2[j].GUBUN_CD) {

        tmpData.DATA_3_RT = chartBaseData["chart2"].DataSub2[i].RT;
        tmpData.DATA_3_GRAD = chartBaseData["chart2"].DataSub2[i].GRAD;
        tmpData.SUM_GRAD_1 += parseInt(tmpData.DATA_3_GRAD);
        break;
      }
    }

    for (let j = 0; j < chartBaseData["chart4"].DataSub2.length; j++) {
      if (tmpData.GUBUN_CD === chartBaseData["chart4"].DataSub2[j].GUBUN_CD) {

        tmpData.DATA_4_RT = chartBaseData["chart4"].DataSub2[i].RT;
        tmpData.DATA_4_GRAD = chartBaseData["chart4"].DataSub2[i].GRAD;
        tmpData.SUM_GRAD_2 += parseInt(tmpData.DATA_4_GRAD);
        break;
      }
    }

    for (let j = 0; j < chartBaseData["chart2"].DataSub1.length; j++) {
      if (tmpData.GUBUN_CD === chartBaseData["chart2"].DataSub1[j].GUBUN_CD) {
        tmpData.DATA_5_RT = chartBaseData["chart2"].DataSub1[i].RT;
        tmpData.DATA_5_GRAD = chartBaseData["chart2"].DataSub1[i].GRAD;
        tmpData.SUM_GRAD_2 += parseInt(tmpData.DATA_5_GRAD);
        break;
      }
    }

    for (let j = 0; j < chartBaseData["chart3"].DataSub1.length; j++) {
      if (tmpData.GUBUN_CD === chartBaseData["chart3"].DataSub1[j].GUBUN_CD) {

        tmpData.DATA_6_RT = chartBaseData["chart3"].DataSub1[i].RT;
        tmpData.DATA_6_GRAD = chartBaseData["chart3"].DataSub1[i].GRAD;
        tmpData.SUM_GRAD_1 += parseInt(tmpData.DATA_6_GRAD);
        break;
      }
    }
    tmpData.SUM_GRAD = parseInt(tmpData.SUM_GRAD_1) + parseInt(tmpData.SUM_GRAD_2);

    chartBaseData["chart5"].Data.push(tmpData);
  }
}
